import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { pick } from 'ramda';
import { usePushSubscription } from 'server';
import uuid from 'uuid-random';

import { useDataFetchWithAwait } from 'js/app/hooks/useDataFetchWithAwait';
import { getAllPlayerTags } from 'js/app/hooks/user/server';
import { fromArrayToObject } from 'js/app/utils/common.util';
import { setAllPlayerTags } from 'js/hooks/user/store/buzz/actions';
import { useUserSelector } from 'js/store/hooks';

export const useAllPlayerTags = ({ isInitFetch, isForceFetch } = {}) => {
    const dispatch = useDispatch();
    const { allPlayerTags, isLoggedIn } = useUserSelector(pick(['allPlayerTags', 'isLoggedIn']));
    const [triggerToUpdated, setTriggerToUpdated] = useState();

    const onResponse = useCallback(({ data: { tags } }) => {
        const tagsObject = fromArrayToObject({
            data: tags,
            key: 'name'
        });

        dispatch(setAllPlayerTags(tagsObject));

        return tagsObject;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const handlerSubscriptionTag = useCallback(() => (pushMessage) => {
        const { notificationPlayerTagChangeInfo } = pushMessage?.data?.notification || {};

        if (notificationPlayerTagChangeInfo && isInitFetch) {
            setTriggerToUpdated(uuid());
        }
    }, [isInitFetch]);

    usePushSubscription(31133, handlerSubscriptionTag);

    const shouldFetch = useCallback(
        () => isForceFetch || isLoggedIn || isLoggedIn && triggerToUpdated,
        [isForceFetch, isLoggedIn, triggerToUpdated]
    );

    return useDataFetchWithAwait({
        fetch: getAllPlayerTags,
        shouldFetch,
        onResponse,
        initialData: allPlayerTags,
        isUpdated: isInitFetch && (!allPlayerTags || triggerToUpdated),
        initFetch: isInitFetch && isLoggedIn && !allPlayerTags
    });
};
